var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrameHomepageMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 510,
    viewBox: "0 0 332 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0415 506.927L12.464 510H21.0181L18.5353 506.863L10.0415 506.927Z",
    fill: "#7AE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.033 506.927L24.4655 510H33.0095L30.5368 506.863L22.033 506.927Z",
    fill: "#7AE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0352 506.927L36.4576 510H45.0117L42.5289 506.863L34.0352 506.927Z",
    fill: "#7AE7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0266 506.927L48.4591 510H57.0032L54.5304 506.863L46.0266 506.927Z",
    fill: "#7AE7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1037V490.505L10.9159 501.757H55.6766L60.7326 508.146H278.987L282.294 503.967H319.214L328.995 491.609V10.1284L322.562 2H165.352L163.241 4.66713H84.4046L82.736 2.55883H11.2778L2 14.1037Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.148 7.49958L277.57 4.42603H286.124L283.652 7.55038L275.148 7.49958Z",
    fill: "#7AE7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.14 7.49958L289.572 4.42603H298.126L295.643 7.55038L287.14 7.49958Z",
    fill: "#7AE7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.141 7.49958L301.574 4.42603H310.118L307.645 7.55038L299.141 7.49958Z",
    fill: "#7AE7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M311.143 7.49958L313.566 4.42603H322.12L319.637 7.55038L311.143 7.49958Z",
    fill: "#7AE7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257.969 505.479L260.391 502.405H268.945L266.463 505.529L257.969 505.479Z",
    fill: "#7AE7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.961 505.479L272.393 502.405H280.937L278.464 505.529L269.961 505.479Z",
    fill: "#7AE7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1037V491.114L10.9159 502.367H55.6766L60.7326 508.755H279.992L283.299 504.577H320.22L330 492.219V10.1284L323.567 2H165.352L163.241 4.66713H84.4046L82.736 2.55883H11.2778L2 14.1037Z",
    stroke: "#7AE7FF",
    strokeWidth: 2.3247,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameHomepageMobile);
export default __webpack_public_path__ + "static/media/FrameHomepageMobile.3c9cf3ce197acdc2ae2a3d79418d8b87.svg";
export { ForwardRef as ReactComponent };